export default "__VITE_ASSET__Al4GuEPC__"